import React from "react";
import styled, { css } from "styled-components";
import { ActiveHotelI, POSITIONS, PositionsT } from "../../Mapview";
import MiniCard from "../MiniCard/MiniCard";

// styles
import styles from "./PropertyMarker.module.scss";

const Marker = styled.div<{
  activeHotel: boolean;
  isMiniCardOpen: boolean;
}>`
  transition: all 0.2s ease-in-out !important;
  min-width: 75px !important;
  min-height: 35px !important;

  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  transform: translate(-50%, -50%) !important;

  border-radius: 10em !important;
  background-color: white !important;
  box-shadow: 0px 0px 6px 2px rgba(112, 112, 112, 0.2) !important;

  cursor: pointer !important;

  p {
    color: black;
    font-size: 0.8em !important;
    font-weight: 600 !important;
  }

  ${(props: { activeHotel: boolean }) => {
    if (props.activeHotel) {
      return css`
        &.active {
          z-index: 700 !important;
          background-color: black !important;
          transform: translate(-50%, -50%) scale(1.1) !important;
          & > *:not(:first-child) {
            color: black !important;
          }
          & * {
            color: white !important;
          }
        }
      `;
    }
  }}

  ${(props: { activeHotel: boolean }) => {
    if (!props.activeHotel) {
      return css`
        &:hover {
          z-index: 800 !important;
          background-color: black !important;
          transform: translate(-50%, -50%) !important;
          & > *:not(:first-child) {
            color: black !important;
          }
          & * {
            color: white !important;
          }
        }
      `;
    }
  }}
`;

const PropertyMarker: React.FC<{
  lat: string | undefined;
  lng: string | undefined;
  hotel: ActiveHotelI;
  activeHotel: ActiveHotelI;
  setActiveHotel: React.Dispatch<React.SetStateAction<ActiveHotelI>>;
  setIsMiniCardOpen: React.Dispatch<React.SetStateAction<boolean>>;
  miniCardEl: React.RefObject<HTMLDivElement>;
  isMiniCardOpen: boolean;
  miniCardPosition: PositionsT[];
  isBiggerThanXm: boolean;
  isBiggerThanM: boolean;
}> = (props) => {
  const {
    hotel,
    activeHotel,
    setActiveHotel,
    setIsMiniCardOpen,
    isMiniCardOpen,
    miniCardEl,
    miniCardPosition,
    isBiggerThanM
  } = props;

  const miniCardPositionStyles = {
    left: miniCardPosition.includes(POSITIONS.LEFT) ? "0" : "50%",
    top: miniCardPosition.includes(POSITIONS.TOP) ? "0" : "100%"
  };

  const handleClick = (e: React.MouseEvent) => {
    setActiveHotel(hotel);
    setIsMiniCardOpen(true);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={`${styles.propertyMarker} marker`}>
        <Marker
          activeHotel={activeHotel.id === hotel.id ? true : false}
          isMiniCardOpen={isMiniCardOpen}
          // onMouseEnter={() => setActiveHotel(hotel)}
          onClick={handleClick}
          className={`marker ${activeHotel.id === hotel.id && "active"}`}
        >
          <p className="marker">{hotel.price}</p>
        </Marker>
        {activeHotel.id === hotel.id && isMiniCardOpen && isBiggerThanM && (
          <div
            style={miniCardPositionStyles}
            className={`${styles.miniCard} ${
              miniCardPosition.includes(POSITIONS.TOP) && styles.top
            } ${miniCardPosition.includes(POSITIONS.LEFT) && styles.left}`}
            ref={miniCardEl}
          >
            <MiniCard
              hotel={activeHotel}
              lat={activeHotel.lat}
              lng={activeHotel.lng}
              miniCardEl={miniCardEl}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyMarker;
